import axios from 'axios';
import ConfigAxios from './ConfigAxios';

const getAllRoles = () => {
    let {NERTHUS, options} = ConfigAxios();
    return axios.get(NERTHUS + '/users/roles', options);
};

const getRoleById = dataRoleId => {
    let {NERTHUS, options} = ConfigAxios();
    return axios.get(NERTHUS + '/users/roles/code/' + dataRoleId, options);
};

const createRole = dataRole => {
    let {NERTHUS, options} = ConfigAxios();
    return axios.post(NERTHUS + '/users/roles', dataRole, options);
};

const updateRole = (dataRole, dataRoleId) => {
    let {NERTHUS, options} = ConfigAxios();
    return axios.put(NERTHUS + '/users/roles/code/' + dataRoleId, dataRole, options);
};

const deleteRole = dataRoleId => {
    let {NERTHUS, options} = ConfigAxios();
    return axios.delete(NERTHUS + '/users/roles/code/' + dataRoleId, options);
};

const RoleCrudService = {
    getAllRoles,
    getRoleById,
    createRole,
    updateRole,
    deleteRole
};

export default RoleCrudService;